export const COORDINATES_DECIMAL_PLACES = 5
export const AREA_DECIMAL_PLACES = 2

// Scale the user needs to be zoomed in beyond to edit drawings on the map (1:${scaleCutoff})
export const scaleCutoff = 50000
// The scale closest to the scaleCutoff that corresponds to a zoom level preset:
export const scaleToZoomToForEdits = 36111
// The user has to be zoomed in past 1 : ${minWDPAScale} to see the WDPA layers:
export const minWDPAScale = 10000000
